/* Refined cart page and native AJAX compatibility on every cart viewport. */
(function () {
  'use strict';
  if (!document.documentElement.classList.contains('asm-page-cart')) return;
  let queued = false;
  let started = false;
  let clearing = false;
  let closing = false;
  let modalReturn;
  const cartIcon = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 3h2l2.1 11.4a2 2 0 0 0 2 1.6h8.5a2 2 0 0 0 2-1.6L21 7H6"/><circle cx="10" cy="20" r="1"/><circle cx="18" cy="20" r="1"/></svg>';

  function text(element, value) {
    if (element && element.textContent !== value) element.textContent = value;
  }

  function localize(cart) {
    if (document.title !== 'Səbətim — ASM Kitchenware') document.title = 'Səbətim — ASM Kitchenware';
    text(cart.querySelector('.cart__empty-text'), 'Səbətiniz boşdur');
    text(cart.querySelector('.cart-items caption'), 'Səbətim');
    cart.querySelectorAll('.cart-item').forEach(row => {
      const title = row.querySelector('.cart-item__name')?.textContent.trim() || 'Məhsul';
      row.querySelectorAll('.quantity__button').forEach(button => {
        const label = button.name === 'minus' ? 'Miqdarı azalt' : 'Miqdarı artır';
        button.setAttribute('aria-label', label);
        text(button.querySelector('.visually-hidden'), label);
      });
      row.querySelector('.quantity__input')?.setAttribute('aria-label', title + ' — miqdar');
      row.querySelector('cart-remove-button a')?.setAttribute('aria-label', title + ' məhsulunu sil');
      row.querySelectorAll('.product-option dt').forEach(label => {
        if (/^(order type|sales unit|sifariş növü|satış vahidi)\s*:?$/i.test(label.textContent.trim())) text(label, 'Satış vahidi:');
      });
    });
  }

  function refresh() {
    queued = false;
    const main = document.getElementById('MainContent');
    const cart = main?.querySelector('cart-items');
    if (!cart) return;
    localize(cart);
    let heading = main.querySelector('.asm-touch-cart-heading');
    if (!heading) {
      heading = document.createElement('section');
      heading.className = 'asm-touch-cart-heading';
      heading.setAttribute('aria-labelledby', 'asm-touch-cart-title');
      heading.innerHTML = '<div class="asm-touch-cart-heading__top"><h1 id="asm-touch-cart-title">Səbətim</h1><span class="asm-touch-cart-count"></span></div><p>Məhsulları və seçdiyiniz miqdarları yoxlayın.</p>';
      main.insertBefore(heading, main.firstChild);
    }
    const count = cart.querySelectorAll('.cart-item').length;
    const counter = heading.querySelector('.asm-touch-cart-count');
    const label = count + ' məhsul';
    if (counter.textContent !== label) counter.textContent = label;
    const empty = count === 0;
    if (cart.classList.contains('is-empty') !== empty) cart.classList.toggle('is-empty', empty);
    main.querySelectorAll('.asm-order-panel').forEach(panel => {
      const wrapper = panel.closest('.page-width');
      if (wrapper && wrapper.classList.contains('asm-touch-cart-details-empty') !== empty) wrapper.classList.toggle('asm-touch-cart-details-empty', empty);
      if (wrapper && wrapper.hidden !== empty) wrapper.hidden = empty;
    });
    const clearRow = cart.querySelector('.asm-cart-clear-row');
    if (clearRow && clearRow.hidden !== empty) clearRow.hidden = empty;
    const clearButton = cart.querySelector('.asm-cart-clear-all');
    if (clearButton) clearButton.disabled = cart.querySelector('.cart__items')?.classList.contains('cart__items--disabled') || clearing;
    const warning = cart.querySelector('.cart__warnings');
    if (warning && !warning.querySelector('.asm-touch-cart-empty-icon')) {
      const icon = document.createElement('div');
      icon.className = 'asm-touch-cart-empty-icon';
      icon.innerHTML = cartIcon;
      warning.insertBefore(icon, warning.firstChild);
      const description = document.createElement('p');
      description.className = 'asm-touch-cart-empty-description';
      description.textContent = 'Bəyəndiyiniz məhsulları seçib səbətə əlavə edin.';
      const title = warning.querySelector('.cart__empty-text');
      if (title) title.insertAdjacentElement('afterend', description);
    }
    if (!document.getElementById('cart-errors')) {
      const errors = document.createElement('p');
      errors.id = 'cart-errors';
      errors.className = 'asm-touch-cart-errors';
      errors.setAttribute('role', 'alert');
      cart.querySelector('.page-width')?.appendChild(errors);
    }
  }

  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(refresh);
  }

  function playModalAnimation(modal, state, animationName, duration) {
    const panel = modal.querySelector('.asm-cart-clear-modal__panel');
    if (!panel || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      modal.classList.add(state);
      return Promise.resolve();
    }
    return new Promise(resolve => {
      let timer;
      const finish = event => {
        if (event && (event.target !== panel || event.animationName !== animationName)) return;
        clearTimeout(timer);
        panel.removeEventListener('animationend', finish);
        panel.removeEventListener('animationcancel', finish);
        resolve();
      };
      panel.addEventListener('animationend', finish);
      panel.addEventListener('animationcancel', finish);
      timer = setTimeout(finish, duration + 100);
      modal.classList.add(state);
    });
  }

  async function closeClearModal(afterClear = false) {
    if ((clearing && !afterClear) || closing) return;
    const modal = document.getElementById('AsmClearCartModal');
    if (!modal || modal.hidden) return;
    closing = true;
    modal.classList.remove('is-success');
    await playModalAnimation(modal, 'is-closing', 'asmCartModalOut', 180);
    modal.hidden = true;
    modal.classList.remove('is-closing', 'is-success');
    document.documentElement.classList.remove('asm-cart-modal-open');
    if (typeof removeTrapFocus === 'function') removeTrapFocus();
    const target = afterClear ? document.querySelector('.asm-cart-home-link') :
      (modalReturn?.isConnected ? modalReturn : document.querySelector('.asm-cart-clear-all,.asm-cart-home-link'));
    target?.focus({ preventScroll: true });
    closing = false;
  }

  function openClearModal(button) {
    if (clearing || closing || button.disabled) return;
    const modal = document.getElementById('AsmClearCartModal');
    if (!modal || !modal.hidden) return;
    modalReturn = button;
    modal.classList.remove('is-closing', 'is-success');
    modal.querySelector('.asm-cart-clear-modal__error').hidden = true;
    modal.hidden = false;
    document.documentElement.classList.add('asm-cart-modal-open');
    const cancel = modal.querySelector('.asm-cart-clear-modal__cancel');
    if (typeof trapFocus === 'function') trapFocus(modal.querySelector('.asm-cart-clear-modal__panel'), cancel);
    else cancel.focus();
  }

  async function clearCart() {
    if (clearing || closing) return;
    const modal = document.getElementById('AsmClearCartModal');
    const cart = document.querySelector('#MainContent cart-items');
    if (!modal || modal.hidden || !cart || cart.querySelector('.cart__items--disabled')) return;
    const confirm = modal.querySelector('.asm-cart-clear-modal__confirm');
    const cancel = modal.querySelector('.asm-cart-clear-modal__cancel');
    const error = modal.querySelector('.asm-cart-clear-modal__error');
    clearing = true;
    confirm.disabled = cancel.disabled = true;
    text(confirm, 'Silinir…');
    error.hidden = true;
    refresh();
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(window.routes?.cart_clear_url || root + 'cart/clear.js', {
        method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      });
      if (!response.ok) throw new Error('Səbəti təmizləmək alınmadı. Yenidən cəhd edin.');
      const state = await response.json();
      if (!Array.isArray(state.items) || state.items.length || Number(state.item_count) !== 0) {
        throw new Error('Səbəti yeniləmək alınmadı. Yenidən cəhd edin.');
      }
      // The successful clear response confirms empty state; update it without another page request.
      cart.querySelector('#main-cart-items .js-contents')?.replaceChildren();
      cart.classList.add('is-empty');
      if (window.asmUpdateCartCount) window.asmUpdateCartCount(0);
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: state });
      }
      refresh();
      await playModalAnimation(modal, 'is-success', 'asmCartModalSuccess', 550);
      await closeClearModal(true);
    } catch (_) {
      text(error, 'Səbəti təmizləmək alınmadı. Yenidən cəhd edin.');
      error.hidden = false;
    } finally {
      clearing = false;
      confirm.disabled = cancel.disabled = false;
      text(confirm, 'Hamısını sil');
      refresh();
    }
  }

  function start() {
    if (started) return;
    started = true;
    if (window.cartStrings) Object.assign(window.cartStrings, {
      error: 'Səbəti yeniləmək alınmadı. Yenidən cəhd edin.',
      quantityError: 'Bu məhsuldan yalnız [quantity] ədəd mövcuddur.'
    });
    if (window.quickOrderListStrings) Object.assign(window.quickOrderListStrings, {
      min_error: 'Minimum miqdar: [min].',
      max_error: 'Maksimum miqdar: [max].',
      step_error: 'Miqdar [step] vahidlik artımla seçilməlidir.'
    });
    refresh();
    document.addEventListener('click', function (event) {
      const clear = event.target.closest('.asm-cart-clear-all');
      if (clear) { event.preventDefault(); openClearModal(clear); return; }
      const modal = event.target.closest('#AsmClearCartModal');
      if (!modal) return;
      if (event.target.closest('[data-asm-clear-close]')) { event.preventDefault(); closeClearModal(); }
      else if (event.target.closest('.asm-cart-clear-modal__confirm')) { event.preventDefault(); clearCart(); }
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !document.getElementById('AsmClearCartModal')?.hidden) closeClearModal();
    });
    document.addEventListener('click', function (event) {
      if (!window.asmSelectionMemory) return;
      const button = event.target.closest('cart-items quantity-input .quantity__button');
      if (!button) return;
      const row = button.closest('.cart-item');
      const input = row?.querySelector('.quantity__input[data-quantity-variant-id]');
      const link = row?.querySelector('a[href*="/products/"]');
      if (!input || !link) return;
      try {
        const handle = decodeURIComponent(new URL(link.href).pathname.split('/products/')[1]?.split('/')[0] || '');
        // QuantityInput has already applied the step by the document bubble phase.
        window.asmSelectionMemory.remember(handle, input.dataset.quantityVariantId, input.value);
      } catch (_) {}
    });
    const main = document.getElementById('MainContent');
    if (main) new MutationObserver(schedule).observe(main, {
      childList: true, subtree: true, attributes: true, attributeFilter: ['class']
    });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, schedule);
    }
  }

  customElements.whenDefined('cart-items').then(function () {
    const prototype = customElements.get('cart-items').prototype;
    const original = prototype.getSectionsToRender;
    if (!original || prototype.__asmTouchCartSections) return;
    prototype.__asmTouchCartSections = true;
    const updateLiveRegions = prototype.updateLiveRegions;
    prototype.updateLiveRegions = function (line, message) {
      if (message) {
        if (typeof message !== 'string') message = window.cartStrings?.error || 'Səbəti yeniləmək alınmadı.';
        else if (/\b(sold out|out of stock|not enough|can't add more|cannot add more|not available)\b/i.test(message)) {
          message = 'Seçilən miqdar mövcud deyil. Miqdarı azaldıb yenidən cəhd edin.';
        } else if (/\b(error|unable|please|cannot|not found|invalid|failed)\b/i.test(message)) {
          message = window.cartStrings?.error || 'Səbəti yeniləmək alınmadı.';
        }
      }
      return updateLiveRegions.call(this, line, message);
    };
    prototype.getSectionsToRender = function () {
      // This catalog's cart uses asm-order-details instead of Dawn's cart footer.
      const sections = [
        { id: 'main-cart-items', selector: '.js-contents' },
        { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' },
        { id: 'cart-live-region-text', section: 'cart-live-region-text', selector: '.shopify-section' },
        { id: 'main-cart-footer', selector: '.js-contents' }
      ];
      return sections.filter(section => document.getElementById(section.id)).map(section => ({
        ...section, section: section.section || document.getElementById(section.id).dataset.id
      })).filter(section => section.section);
    };
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
